import { render, staticRenderFns } from "./archivio.html?vue&type=template&id=415106ab&scoped=true&external"
import script from "./Archivio.vue?vue&type=script&lang=js"
export * from "./Archivio.vue?vue&type=script&lang=js"
import style0 from "./Archivio.vue?vue&type=style&index=0&id=415106ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415106ab",
  null
  
)

export default component.exports